var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{active: this.active, 'components-edit-shape': _vm.edit},on:{"click":_vm.handleTopWrapperClick,"touchend":_vm.handleMouseDownOnElement}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }